import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2021/App/E1/";

export const app2021 = [
    {
        'numInvitacion' : 'APP-913005997-E1-2021',
        'procedimiento' : [
            {
                'numProc' : 'Concurso Público No. APP-913005997-E1-2021',
                'vigenciaProc' : 'Fecha límite para adquirir las Bases Generales del Concurso: 12 de marzo de 2021',
                'descripcionProc' : 'Concurso para la adjudicación de un proyecto de Asociación Público Privada, para la prestación del servicio de disponibilidad de la “Carretera Real del Monte – Entronque Huasca”, en el Estado de Hidalgo, así como el otorgamiento de una concesión de Jurisdicción Estatal por 30 años para la Construcción, Operación, Explotación, Conservación y Mantenimiento de la “Carretera Real del Monte – Entronque Huasca”, en el Estado de Hidalgo.',
                'urlDictamen' : `${ ligabase }DE1.PDF`,
                'urlAnexos' : `${ ligabase }AppE1.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Presentación para Taller Informativo',
                        'urlResultado' : `${ ligabase }PTIE1.pdf`,
                    },
                    {
                        'resultado' : 'Taller de Información',
                        'urlResultado' : `${ ligabase }TIE1.pdf`,
                    },
                    {
                        'resultado' : 'Acta Circunstanciada de la visita al sitio',
                        'urlResultado' : `${ ligabase }ACVSE1.pdf`,
                    },
                    {
                        'resultado' : 'Notificación',
                        'urlResultado' : `${ ligabase }NE1.pdf`,
                    },
                    {
                        'resultado' : 'Junta de Aclaraciones y Anexos',
                        'urlResultado' : `${ ligabase }JAE1.rar`,
                    },
                    {
                        'resultado' : 'Notificación 2',
                        'urlResultado' : `${ ligabase }N2E1.rar`,
                    },
                    {
                        'resultado' : 'Versión PDF segundaApertura de Proposiciones junta de aclaraciones',
                        'urlResultado' : `${ ligabase }APE1.rar`,
                    },
                    {
                        'resultado' : 'Oficios',
                        'urlResultado' : `${ ligabase }OE1.pdf`,
                    },
                    {
                        'resultado' : 'Resultado de la evaluación de las Ofertas Técnicas y apertura de las Ofertas Económicas',
                        'urlResultado' : `${ ligabase }REOE1.pdf`,
                    },
                    {
                        'resultado' : 'Notificación 3',
                        'urlResultado' : `${ ligabase }N3E1.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligabase }FAE1.pdf`,
                    },
                ]
            }
        ]
    }
]